import { Table, TableBody, TableCell, TableRow } from "@8x8/oxygen-table";
import React, { createContext, memo, useEffect, useState } from "react";
import HorizontalTableHeader from "@/react/features/globalization/HorizontalTableHeader";
import styled, { css } from "styled-components";
import { TableLoadingSpinnerWrapper } from "@/react/components/table/styled";

const NonPrintableTableRow = styled(TableRow)`
  ${({ notPrintable }) =>
    notPrintable &&
    css`
      @media print {
        display: none !important;
      }
    `};
`;

const StyledTableCell = styled(TableCell)`
  vertical-align: top;
  overflow: visible;
`;

const Title = styled.h5`
  margin: 0;
  padding-top: 24px;
  padding-bottom: 24px;
`;

export const HorizontalTableContext = createContext({
  isEdit: false,
  meta: { rights: [] },
});

function HorizontalTable(props) {
  const [columns, setColumns] = useState(props.columns);

  useEffect(() => {
    if (props.meta && props.hasOwnProperty("canEdit")) {
      const allColumns = [...props.columns];
      allColumns.forEach((column) => {
        column.isEditable = props.canEdit(props.meta, column);
      });
      setColumns(allColumns);
    }
  }, [props.columns, props.meta]);

  return (
    <>
      {props.isLoading && <TableLoadingSpinnerWrapper />}
      {props.title && <Title>{props.title}</Title>}
      <HorizontalTableContext.Provider
        value={{ isEdit: props.isEdit, meta: props.meta }}
      >
        <Table>
          <TableBody>
            {columns.map((column) => (
              <NonPrintableTableRow
                key={column.id ? column.id : column.name}
                notPrintable={
                  column.hasOwnProperty("isPrintable") &&
                  column.isPrintable === false
                }
              >
                <HorizontalTableHeader
                  title={column.name}
                  tooltip={column.tooltip || column.name}
                />
                {props.data &&
                  props.data.map((item) => {
                    const cellContent = column.hasOwnProperty("render")
                      ? column.render(item, { ...props })
                      : column.field(item);

                    return (
                      <StyledTableCell key={item.id ? item.id : item.name}>
                        {!props.isEdit && cellContent}
                        {props.isEdit &&
                          (column.isEditable && column.hasOwnProperty("edit")
                            ? column.edit(
                                item,
                                props.onCellChange,
                                props.meta || {}
                              )
                            : cellContent)}
                      </StyledTableCell>
                    );
                  })}
              </NonPrintableTableRow>
            ))}
          </TableBody>
        </Table>
      </HorizontalTableContext.Provider>
    </>
  );
}

export const MemoHorizontalTable = memo(HorizontalTable);
